import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';
import { useAuth } from './AuthContext';

const FincaContext = createContext(null);

export function FincaProvider({ children }) {
  const { usuario } = useAuth();
  const [fincas, setFincas] = useState([]);
  const [fincaActiva, setFincaActiva] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Cargar las fincas disponibles
  useEffect(() => {
    if (!usuario) {
      setFincas([]);
      setFincaActiva(null);
      setCargando(false);
      return;
    }

    const cargar = async () => {
      try {
        const { data } = await api.get('/fincas');
        setFincas(data);

        // Para super_admin: respetar la finca activa guardada, o usar null = "todas"
        if (usuario.rol === 'super_admin') {
          const stored = localStorage.getItem('fincaActivaId');
          if (stored && data.some(f => f.id === stored)) {
            setFincaActiva(data.find(f => f.id === stored));
          } else {
            setFincaActiva(null); // "Todas"
          }
        } else {
          // Otros roles: siempre su finca
          const miFinca = data.find(f => f.id === usuario.finca_id);
          setFincaActiva(miFinca || null);
        }
      } catch (err) {
        console.error('Error cargando fincas:', err);
      } finally {
        setCargando(false);
      }
    };

    cargar();
  }, [usuario]);

  const cambiarFinca = (finca) => {
    setFincaActiva(finca);
    if (finca) {
      localStorage.setItem('fincaActivaId', finca.id);
    } else {
      localStorage.removeItem('fincaActivaId');
    }
    // Recargar la página para que todas las vistas usen el nuevo contexto
    window.location.reload();
  };

  const esSuperAdmin = usuario?.rol === 'super_admin';

  return (
    <FincaContext.Provider value={{
      fincas,
      fincaActiva,
      cambiarFinca,
      esSuperAdmin,
      cargando,
    }}>
      {children}
    </FincaContext.Provider>
  );
}

export function useFinca() {
  const context = useContext(FincaContext);
  if (!context) {
    throw new Error('useFinca debe usarse dentro de FincaProvider');
  }
  return context;
}

// Hook helper: devuelve el finca_id que debe usar la página
export function useFincaId() {
  const { fincaActiva, fincas } = useFinca();

  // Si hay finca activa seleccionada, esa
  if (fincaActiva?.id) return fincaActiva.id;

  // Si no, la primera finca disponible
  if (Array.isArray(fincas) && fincas.length > 0) return fincas[0].id;

  return null;
}